/* template */
<template><div class="scroll-text"><mpx-image src="https://ut-static.udache.com/webx/ut/gUdI6BekwFK6ILClO793O.png" class="icon"></mpx-image><div class="scroll-content"><div :style='[("transform: translateX(-"+(marqueeDistance)+"px)")] | transRpxStyle' class="marquee_text"><span class="text">{{text}}</span><span class="text-placeholder">{{text}}</span></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m109be98e"}'>
span {
  white-space: unset
}
.scroll-text
  display flex
  justify-content center
  align-items center
  margin 30rpx auto 40rpx auto
  width 680rpx
  height 54rpx
  background #FF9D42
  box-shadow inset 0rpx 1rpx 6rpx 0rpx rgba(186,100,19,0.25)
  border-radius 16rpx
  font-family PingFangSC-Regular
  font-size 22rpx
  color #FFFFFF
  letter-spacing 1rpx
  font-weight 400
  .icon
    width 28rpx
    height 24rpx
    margin-right: 8rpx;
.scroll-content
  position:relative;
  display:block;
  overflow:hidden;
  width 598rpx
  white-space: nowrap;
  .text
    padding-right 10rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m109be98e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./scroll-text.mpx.js?isComponent&outputPath=components%2Fscroll-text109be98e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./scroll-text.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fscroll-text109be98e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m109be98e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/scroll-text109be98e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
